import {COLORS} from './constants';

export const addColorOptions = (arr) =>
  arr.map((element, index) => ({...element, color: COLORS[index % COLORS.length]}));

export const getSortedTagList = (tagList) =>
  [...tagList].sort((a, b) => (a.title > b.title ? 1 : -1));

export const exportJson = (json, name) => {
  const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(json, null, 2)
  )}`;

  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataStr);
  downloadAnchorNode.setAttribute('download', `${name}.json`);

  document.body.appendChild(downloadAnchorNode); // required for firefox

  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};

export const range = (start, end) => {
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx);
};
